module.exports = __webpack_public_path__ + "img/logo.42250f81.png";